var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { space, fontSize, fontWeight, letterSpacing, lineHeight, textStyle, width, compose, } from 'styled-system';
import propTypes from '@styled-system/prop-types';
import { applyVariations, getPaletteColor, deprecatedColorValue, textStylesValues, typographyAttrs, } from '../utils';
var nowrap = function (props) {
    return props.nowrap
        ? {
            whiteSpace: 'nowrap',
        }
        : null;
};
var accessiblyHide = function (props) {
    return props.hidden
        ? {
            position: 'absolute',
            width: '1px',
            height: '1px',
            clip: 'rect(1px, 1px, 1px, 1px)',
        }
        : null;
};
var labelPropTypes = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, propTypes.space), propTypes.fontSize), propTypes.fontWeight), propTypes.lineHeight), propTypes.textStyle), propTypes.width), { color: deprecatedColorValue(), textStyle: PropTypes.oneOf(textStylesValues) });
var Label = styled.label.attrs(function (props) { return (__assign(__assign({}, typographyAttrs(props)), props)); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n  margin: 0;\n  color: ", ";\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n  ", "\n\n  ", "\n"], ["\n  display: block;\n  width: 100%;\n  margin: 0;\n  color: ", ";\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n  ", "\n\n  ", "\n"])), getPaletteColor('base'), function (props) { return (props.bg ? "background-color: ".concat(getPaletteColor(props.bg, 'base')(props), ";") : ''); }, function (props) { return (props.onClick ? 'cursor: pointer;' : ''); }, applyVariations('Label'), nowrap, accessiblyHide, function (props) { return compose(fontSize, fontWeight, lineHeight, letterSpacing, space, textStyle, width)(props); });
Label.propTypes = labelPropTypes;
Label.defaultProps = {
    color: 'text.light',
    textStyle: 'label',
};
Label.displayName = 'Label';
Label.isLabel = true;
export default Label;
var templateObject_1;
//# sourceMappingURL=Label.js.map